import { render, staticRenderFns } from "./Hand-protection-experts.vue?vue&type=template&id=a1fc67c0&"
import script from "./Hand-protection-experts.vue?vue&type=script&lang=js&"
export * from "./Hand-protection-experts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports